<div class="main-container">
    <p-toast></p-toast>
    <div class="left-container">
      <div [formGroup]="templateForm" class="booking-form" *ngIf="templateForm">
        <div>
          Name
          <input pInputText formControlName="name" class="name-input">
        </div>
        <div>
          School
          <p-dropdown [filter]="true" filterBy="name" dataKey="id" [options]="schoolList" formControlName="school" optionLabel="name"></p-dropdown>
        </div>
        <div>
          Language
          <p-dropdown dataKey="id" [options]="languageList" formControlName="language" optionLabel="name"></p-dropdown>
        </div>
        <div class="description-box">
          <p class="global-title">
            Title
          </p>
          <input pInputText formControlName="description">
        </div>
        <div class="comment-box">
          <p class="global-title">
            Comments
          </p>
          <ckeditor [editor]="Editor" formControlName="comment"></ckeditor>
        </div>
        <div class="quotation-options-container">
          <div>
            <p class="global-title">
              Base currency
            </p>
            <p-dropdown [options]="currencies" optionLabel="isoCode" formControlName="baseCurrency">
            </p-dropdown>
          </div>
          <div>
            <p class="global-title">
              Second currency
            </p>
            <p-dropdown placeholder="--" [options]="currencies" optionLabel="isoCode"
              formControlName="secondCurrency"></p-dropdown>
          </div>
        </div>
        <table class="transaction-table">
          <tr class="first-table-row">
            <th>#</th>
            <th>Type</th>
            <th class="description-th">Remarks</th>
            <th>Price</th>
            <th class="currency-th">Currency</th>
            <!-- Base currency -->
            <th>{{templateForm.get('baseCurrency')!.value!.isoCode}}</th>
            <!-- Second currency -->
            <th *ngIf="templateForm.get('secondCurrency')!.value">
              {{templateForm.get('secondCurrency')!.value!.isoCode}}</th>
              <th>
                Actions
              </th>
          </tr>
          <tr class="no-record-tr" *ngIf="productFormArray.length==0">
              <td colspan="6">
                  <div class="no-record-row">
                      <p class="no-record-message">
                        No record
                      </p>
                      <div class="icon-wrap" (click)="insertItem(0)">
                        <i class="pi pi-plus"></i>
                      </div>
                    </div>
              </td>
          </tr>
          <tr formArrayName="products"
            *ngFor="let product of productFormArray; let i = index"
            (mouseenter)="mouseover(i)" (mouseleave)="mouseout(i)">
            <td [formGroupName]="i">
              {{i + 1}}
            </td>
            <td [formGroupName]="i">
              <p-dropdown [options]="productTypes" formControlName="type" optionLabel="name"></p-dropdown>
            </td>
            <td [formGroupName]="i" class="description-container">
              <textarea [rows]="1" pInputTextarea formControlName="description" [autoResize]="true" id="description-input"></textarea>
            </td>
            <td [formGroupName]="i">
              <input pInputText formControlName="amount" id="amount-input">
            </td>
            <td [formGroupName]="i">
              <p-dropdown [style]="{'minWidth':'50px'}" [options]="currencies" formControlName="currency" optionLabel="isoCode"></p-dropdown>
            </td>
            <td>
              {{productPriceInCurrency[i]}}
            </td>
            <td *ngIf="templateForm.get('secondCurrency')!.value">
              {{productPriceInSecondCurrency[i]}}
            </td>
            <td>
              <table class="hover-menu">
                <tr>
                  <td>
                    <div class="icon-container">
                      <i class="pi pi-caret-up" (click)="moveUp(i)"></i>
                    </div>
                  </td>
                  <td>
                    <div class="icon-container">
                      <i class="pi pi-caret-down" (click)="moveDown(i)"></i>
                    </div>
                  </td>
                  <td>
                    <div class="icon-container">
                      <i class="pi pi-plus-circle" (click)="insertItem(i)"></i>
                    </div>
                  </td>
                  <td>
                    <div class="icon-container">
                      <i class="pi pi-times-circle" (click)="removeItem(i)"></i>
                    </div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
        <div class="price-includes-container">
          <div class="price-includes-editor-container">
            <p class="global-title">
              Prices include
            </p>
            <ckeditor [editor]="Editor" formControlName="priceIncludes"></ckeditor>
          </div>
          <div class="price-includes-editor-container">
            <p class="global-title">
              Prices do not includes
            </p>
            <ckeditor [editor]="Editor" formControlName="priceNotIncludes"></ckeditor>
          </div>
        </div>
      </div>
    </div>
    <div class="right-container">
      <p>Actions</p>
      <div class="submit-delete-button-container">
        <p-button label="Submit" (onClick)="updateQuotationTemplate()"></p-button>
        <p-button icon="pi pi-trash" styleClass="p-button-danger" label="Delete" (onClick)="archiveQuotationTemplate()"></p-button>
      </div>
    </div>
  </div>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle">
  </p-confirmDialog>
  
  

